// extracted by mini-css-extract-plugin
export default {"container":"DownloadBar_container__CSkAl","large":"DownloadBar_large__II0qG","block":"DownloadBar_block__8AqL3"};